import * as React from 'react';
import Grid, { Props as GridProps } from '../Grid/Grid';

interface Props extends GridProps {}

const DatePickerGrid: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Grid { ...props }
        className="DatePicker__grid"
        gapVertical="x1"
        repeat="7"
        repeatWidth="3rem" />
  );
};

export default DatePickerGrid;
